/* eslint-disable import/no-unresolved */
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
  Link, useHistory, useLocation,
  BrowserRouter as Router, useParams,
} from 'react-router-dom';
import {
  setCidade, getIdCidadeEcrie, setAuthToken, setTotem, getTotem,
} from '../../api/apiFactory';
import {
  fetchCidades, fetchLimparCookie,
  fetchNomeCidade, fetchConfiguracoes, fetchVerificarStatusCidade, fetchCarregarSolicitante, fetchSecretarias2, fetchSecretarias3, fetchSecretarias,
} from '../../api/endpoints';
import {
  definirCidade, fetchConfiguracoesCidade, selectCidade, desfazerCidade,
} from '../../app/slices/cidadesSlice';
import { desfazerConexao, selectLogin } from '../../app/slices/loginSlice';
import {
  abrirModalAjuda, abrirModalLoginManifestacao, abrirModalTotemEscolhaLoginManifestacao, abrirModalTotemLoginManifestacao, resetarModais, selectModal,
} from '../../app/slices/modalSlice';
import { definirSecretaria, selectSecretaria, desfazerSecretaria } from '../../app/slices/secretariasSlice';
import AppHeader from '../../components/AppHeader/AppHeader';
import Botao from '../../components/Botao/Botao';
import Carregar from '../../components/Carregar/Carregar';
import FormularioManifestacao from '../../components/FormularioManifestacao/FormularioManifestacao';
import FormularioManifestacaoTotem from '../../components/FormularioManifestacao/FormularioManifestacaoTotem?v=2023-04-19T16:50:00';
import FormularioSic from '../../components/FormularioSic/FormularioSic';
import FormularioSicTotem from '../../components/FormularioSic/FormularioSicTotem?v=2023-04-19T16:50:00';
import GridBotao from '../../components/GridBotao/GridBotao';
import ModalAjuda from '../../components/ModalAjuda/ModalAjuda';
import ModalAssunto from '../../components/ModalAssunto/ModalAssunto';
import ModalBairro from '../../components/ModalBairro/ModalBairro';
import ModalCategoria from '../../components/ModalCategoria/ModalCategoria';
import ModalContato from '../../components/ModalContato/ModalContato';
import ModalEnquete from '../../components/ModalEnquete/ModalEnquete';
import ModalEscolhaLoginTotem from '../../components/ModalEscolhaLoginTotem/ModalEscolhaLoginTotem';
import ModalLogin from '../../components/ModalLogin/ModalLogin?v=2023-04-19T16:50:00';
import ModalLoginTotem from '../../components/ModalLoginTotem/ModalLoginTotem?v=2023-04-19T16:50:00';
import ModalProtocolo from '../../components/ModalProtocolo/ModalProtocolo';
import ModalUnidade from '../../components/ModalUnidade/ModalUnidade';
import ModalAnonimo from '../../components/ModalAnonimo/ModalAnonimo';
import VisualizadorArquivos from '../../components/VisualizadorArquivos/VisualizadorArquivos';
import {
  Alerta, AppBody, AppFragment, BreadCumbs, CampoForm,
  Container, Divisor, Grid, Linha, Titulo, TituloAjuda,
} from '../../styles/base';
import { espacamento } from '../../styles/constants/sizes';
import { isCorClara } from '../../util/color';
import { replaceDiacritico } from '../../util/stringFactory';
import FormularioZeladoriaTotem from '../../components/FormularioZeladoria/FormularioZeladoriaTotem';
import FormControl from '../../components/FormControl/FormControl';
import { LinhaForm3 } from '../../components/FormControl/FormControlEstilo';

const SelecionarSecretaria = ({ sic, ouvidoria, zeladoria }) => {
  const [listaSecretarias, setListaSecretarias] = useState(null);
  const [assunto, setAssunto] = useState('');

  const dispatch = useDispatch();

  const history = useHistory();

  const dadosCidade = useSelector(selectCidade);
  const dadosLogin = useSelector(selectLogin);
  const [nomeUsuario, setNomeUsuario] = useState('');

  const dadosSecretaria = useSelector(selectSecretaria);
  const dadosModal = useSelector(selectModal);

  const [carregando, setCarregando] = useState(false);

  const cookie = document.cookie ? document.cookie : null;
  const cookieSeparado = cookie ? cookie.split('&') : null;
  const cookieSelecionado = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('Id2')) : null;
  const cookieSelecionadoSeparado = cookieSelecionado ? cookieSelecionado.split('=') : null;
  const cookieId = cookieSelecionadoSeparado
    ? cookieSelecionadoSeparado[cookieSelecionadoSeparado.length - 1]
    : null;

  const cookieSelecionado2 = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('IdeCrie')) : null;
  const cookieSelecionadoSeparado2 = cookieSelecionado2 ? cookieSelecionado2.split('=') : null;
  const cookieIdEcrie = cookieSelecionadoSeparado2
    ? cookieSelecionadoSeparado2[cookieSelecionadoSeparado2.length - 1]
    : null;

  window.onload = () => {
    dispatch(resetarModais());
  };

  const limpaLoginAnonimo = (data) => {
    if (data && data.data && data.data.anonimo === 'anonimo') {
      setAuthToken(null);
      dispatch(desfazerConexao());
    }
  };

  const handleVoltar = () => {
    if (history && history.location && history.location.pathname && history.location.pathname.includes('/ouvidoria/')) {
      history.push('/totem/ouvidoria');
    }
    if (history && history.location && history.location.pathname && history.location.pathname.includes('/sic/')) {
      history.push('/totem/sic');
    }
    if (history && history.location && history.location.pathname && history.location.pathname.includes('/zeladoria/')) {
      history.push('/totem/zeladoria');
    }
  };

  const formataNome = (nomes) => {
    const words = nomes.length > 0 && nomes.toLowerCase().split(' ');

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < words.length; i++) {
      words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    }
    return words && words.join(' ');
  };

  const pesquisarSecretariaOuvidoriaPorAssunto = (event) => {
    event.preventDefault();
    setCarregando(true);
    fetchSecretarias(assunto).then(setListaSecretarias);
    setCarregando(false);
  };

  const pesquisarSecretariaSicPorAssunto = (event) => {
    event.preventDefault();
    setCarregando(true);
    fetchSecretarias2(assunto).then(setListaSecretarias);
    setCarregando(false);
  };

  const pesquisarSecretariaZeladoriaPorAssunto = (event) => {
    event.preventDefault();
    setCarregando(true);
    fetchSecretarias3(assunto).then(setListaSecretarias);
    setCarregando(false);
  };

  useEffect(() => {
    if (dadosCidade.data) {
      if (ouvidoria) {
        fetchSecretarias().then(setListaSecretarias);
      } else if (sic) {
        fetchSecretarias2().then(setListaSecretarias);
      } else {
        fetchSecretarias3().then(setListaSecretarias);
      }
    }
    fetchCarregarSolicitante().then((dados) => setNomeUsuario(dados.Solicitante));
  }, []);

  const selecionarSecretaria = (Id, Campo, CorHtml) => {
    if (dadosLogin.data.anonimo === 'naoanonimo') {
      return dispatch(definirSecretaria({
        idSecretaria: Id,
        nomeSecretaria: Campo,
        corSecretaria: CorHtml,
      }));
    }

    // escolhe secretaria
    // if (dadosCidade.configuracoes.OcultarAnonimoOuvidoria === 'N') {
    //   return dispatch(abrirModalLoginManifestacao({
    //     idSecretaria: Id,
    //     nomeSecretaria: Campo,
    //     corSecretaria: CorHtml,
    //   }));
    // }

    // escolhe secretaria
    return dispatch(definirSecretaria({
      idSecretaria: Id,
      nomeSecretaria: Campo,
      corSecretaria: CorHtml,
    }));
  };

  // loader
  if (dadosCidade.data && !listaSecretarias) {
    return (
      <Carregar />
    );
  }

  // abrir formulário manifestação
  if (dadosCidade.data && dadosSecretaria.data) {
    return (
      <AppFragment
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            dispatch(resetarModais());
          }
        }}
        tabIndex="0"
      >
        {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
        {dadosModal.modalLoginTotem === 'aberto' && (<ModalLoginTotem />)}
        {dadosModal.modalEscolhaLoginTotem === 'aberto' && (<ModalEscolhaLoginTotem />)}
        {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
        {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
        {dadosModal.modalArquivo === 'aberto' && (<VisualizadorArquivos />)}
        {dadosModal.modalBairro === 'aberto' && (<ModalBairro />)}
        {dadosModal.modalAssunto === 'aberto' && (<ModalAssunto />)}
        {dadosModal.modalCategoria === 'aberto' && (<ModalCategoria />)}
        {dadosModal.modalUnidade === 'aberto' && (<ModalUnidade />)}
        {dadosModal.modalProtocolo === 'aberto' && (<ModalProtocolo />)}
        {dadosModal.modalAnonimo === 'aberto' && (<ModalAnonimo ouvidoria={ouvidoria} zeladoria={zeladoria} totem />)}
        <AppBody totem={getTotem() === 'true'} desfoque={dadosModal.desfoque}>
          {(ouvidoria) && (<FormularioManifestacaoTotem ouvidoria />)}
          {(sic) && (<FormularioSicTotem sic />)}
          {(zeladoria) && (<FormularioZeladoriaTotem zeladoria />)}
        </AppBody>
      </AppFragment>
    );
  }

  // renderiza lista de secretarias
  if (dadosCidade.data) {
    return (
      <AppFragment
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            dispatch(resetarModais());
          }
        }}
        tabIndex="0"
      >
        {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
        {dadosModal.modalLoginTotem === 'aberto' && (<ModalLoginTotem />)}
        {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
        {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
        {dadosModal.modalAjuda === 'aberto' && (<ModalAjuda />)}
        {dadosModal.modalBairro === 'aberto' && (<ModalBairro />)}
        {dadosModal.modalProtocolo === 'aberto' && (<ModalProtocolo />)}
        {dadosModal.modalEscolhaLoginTotem === 'aberto' && (<ModalEscolhaLoginTotem />)}
        {dadosModal.modalAnonimo === 'aberto' && (<ModalAnonimo ouvidoria={ouvidoria} zeladoria={zeladoria} totem />)}
        {(listaSecretarias.length > 10 && getTotem() === 'true') && (
          <>
            <Botao
              onClick={() => document.getElementById('totemSecretarias').scrollBy({
                top: -350,
                left: 0,
                behavior: 'smooth',
              })}
              totemUp
            />
            <Botao
              onClick={() => document.getElementById('totemSecretarias').scrollBy({
                top: 350,
                left: 0,
                behavior: 'smooth',
              })}
              totemDown
            />
          </>
        )}
        <Botao
          voltar
          label="Voltar"
          style={{
            marginRight: espacamento.pequeno, fontSize: 25, flex: 'unset',
          }}
          onClick={() => handleVoltar()}
        />
        <Botao
          sair
          label="Sair"
          style={{ marginRight: espacamento.pequeno }}
          onClick={() => {
            dispatch(desfazerConexao());
            dispatch(desfazerSecretaria());
            limpaLoginAnonimo(dadosLogin);
            history.push('/totem');
          }}
        />
        <AppBody id="totemSecretarias" totem desfoque={dadosModal.desfoque}>
          <BreadCumbs>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>
                Você está em:
                {' '}
                {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Ouvidoria</span>)}
                {(sic) && (<span style={{ fontWeight: 'bold' }}>Pedido de Informação (e-SIC)</span>)}
                {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Zeladoria</span>)}
                {' '}
                &rsaquo;
                {' '}
                {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Cadastrar uma nova manifestação</span>)}
                {(sic) && (<span style={{ fontWeight: 'bold' }}>Cadastrar um novo pedido</span>)}
                {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Cadastrar uma nova reclamação</span>)}
              </div>
              <div>
                <span style={{ textAlign: 'right' }}>Logado como: </span>
                <span style={{ fontWeight: 'bold', textAlign: 'right' }}>{formataNome(nomeUsuario)}</span>
              </div>
            </div>
          </BreadCumbs>
          <Container style={{ marginTop: 120, paddingInline: 95 }} totem>
            {ouvidoria && (
              <>
                <LinhaForm3>
                  <FormControl
                    idCampo="inputAssunto"
                    value={assunto}
                    label="Assunto:"
                    onChange={({ target }) => setAssunto(target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        pesquisarSecretariaOuvidoriaPorAssunto(e);
                      }
                    }}
                    type="inputTotem"
                  />

                  {carregando !== true
                    ? (
                      <Botao
                        label="Pesquisar"
                        type="submit"
                        onClick={pesquisarSecretariaOuvidoriaPorAssunto}
                        busca
                      />
                    )
                    : (
                      <Carregar />
                    )}
                </LinhaForm3>

                <Divisor size="pequeno" />

                {dadosCidade.configuracoes.TituloAjudaOuvidoria && (
                  <>
                    <TituloAjuda>
                      <div dangerouslySetInnerHTML={{ __html: dadosCidade.configuracoes.TituloAjudaOuvidoria }} />
                    </TituloAjuda>

                    <Divisor size="pequeno" />
                  </>
                )}
              </>
            )}

            {sic && (
              <>
                <LinhaForm3>
                  <FormControl
                    idCampo="inputAssunto"
                    value={assunto}
                    label="Assunto:"
                    onChange={({ target }) => setAssunto(target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        pesquisarSecretariaSicPorAssunto(e);
                      }
                    }}
                    type="inputTotem"
                  />

                  {carregando !== true
                    ? (
                      <Botao
                        label="Pesquisar"
                        type="submit"
                        onClick={pesquisarSecretariaSicPorAssunto}
                        busca
                      />
                    )
                    : (
                      <Carregar />
                    )}
                </LinhaForm3>

                <Divisor size="pequeno" />

                {dadosCidade.configuracoes.TituloAjudaSic && (
                  <>
                    <TituloAjuda>
                      <div dangerouslySetInnerHTML={{ __html: dadosCidade.configuracoes.TituloAjudaSic }} />
                    </TituloAjuda>

                    <Divisor size="pequeno" />
                  </>
                )}
              </>
            )}

            {zeladoria && (
              <>
                <LinhaForm3>
                  <FormControl
                    idCampo="inputAssunto"
                    value={assunto}
                    label="Assunto:"
                    onChange={({ target }) => setAssunto(target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        pesquisarSecretariaZeladoriaPorAssunto(e);
                      }
                    }}
                    type="inputTotem"
                  />

                  {carregando !== true
                    ? (
                      <Botao
                        label="Pesquisar"
                        type="submit"
                        onClick={pesquisarSecretariaZeladoriaPorAssunto}
                        busca
                      />
                    )
                    : (
                      <Carregar />
                    )}
                </LinhaForm3>

                <Divisor size="pequeno" />

                {dadosCidade.configuracoes.TituloAjudaZeladoria && (
                  <>
                    <TituloAjuda>
                      <div dangerouslySetInnerHTML={{ __html: dadosCidade.configuracoes.TituloAjudaZeladoria }} />
                    </TituloAjuda>

                    <Divisor size="pequeno" />
                  </>
                )}
              </>
            )}

            {listaSecretarias.Message ? (
              <p>Não há nenhuma secretaria disponível.</p>
            ) : (
              <Grid totem>
                {listaSecretarias.map(({
                  Campo, Id, Icone, CorHtml,
                }) => (
                  (Icone === 'cincatarina' || Icone === 'conminas' ? (
                    // Se o ícone for da cidade cincatarina, eu fixo uma imagem, largura, altura, e cor diferentes
                    <GridBotao
                      totem
                      onClick={() => selecionarSecretaria(Id, Campo, CorHtml)}
                      key={Id}
                      label={Campo}
                      img={`https://eouve.com.br/svg_icons/dark/${Icone}.png`}
                      size={17}
                      imgWidth={130}
                      imgHeight="unset"
                      cor="#ffffff"
                      secretaria
                    />
                  ) : (
                    <GridBotao
                      totem
                      onClick={() => selecionarSecretaria(Id, Campo, CorHtml)}
                      key={Id}
                      label={Campo}
                      img={`https://eouve.com.br/svg_icons/${isCorClara(CorHtml) ? 'dark' : 'light'}/${Icone}.svg`}
                      size={17}
                      imgWidth={60}
                      imgHeight={60}
                      cor={CorHtml}
                      secretaria
                    />
                  ))
                ))}
              </Grid>
            )}
          </Container>
        </AppBody>
      </AppFragment>
    );
  }
  return true;
};

SelecionarSecretaria.propTypes = {
  ouvidoria: PropTypes.bool,
  sic: PropTypes.bool,
  zeladoria: PropTypes.bool,
};

SelecionarSecretaria.defaultProps = {
  ouvidoria: false,
  sic: false,
  zeladoria: false,
};

export default SelecionarSecretaria;
